// extracted by mini-css-extract-plugin
module.exports = {"faqTitle":"webAttributionSetUp-faqTitle-33aySQ","faqAccordion":"webAttributionSetUp-faqAccordion-3XEVsn","contentSection":"webAttributionSetUp-contentSection-RHXhfA"};